module.exports = __webpack_public_path__ + "static/media/image.ce47147e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/WebsiteVsSocialMediaPages/image.jpg
// module id = 25
// module chunks = 0